// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1-Mh2","title":"card_title__2iZR8","inActive":"card_inActive__1BNf1"};